import { forwardRef, ReactNode, TextareaHTMLAttributes } from 'react';

interface TextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label: string;
  error?: string;
  helperText?: string;
  required?: boolean;
  /** Optional control rendered right-aligned in the label row (e.g. a snippet picker). */
  labelAddon?: ReactNode;
}

export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({ label, error, helperText, required, labelAddon, className = '', rows = 4, ...props }, ref) => {
    return (
      <div className="space-y-1">
        <div className="flex items-center justify-between gap-2">
          <label className="block text-[12px] font-medium text-slate-600">
            {label}
            {required && <span className="text-red-500 ml-1">*</span>}
          </label>
          {labelAddon}
        </div>
        <textarea
          ref={ref}
          rows={rows}
          className={`w-full px-3 py-1.5 rounded-md bg-white border text-[13px] text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-[#00A871]/30 focus:border-[#00A871]/50 disabled:bg-slate-50 disabled:cursor-not-allowed resize-y transition-colors ${
            error ? 'border-red-500 focus:ring-red-500/30' : 'border-slate-200'
          } ${className}`}
          {...props}
        />
        {error && <p className="text-[11px] text-red-600">{error}</p>}
        {helperText && !error && <p className="text-[11px] text-slate-500">{helperText}</p>}
      </div>
    );
  }
);

TextArea.displayName = 'TextArea';
